/* =====================================================================
   LUNEOR — cart add-ons: upsells in the cart drawer + product thrown
   into the cart icon when "Add to cart" is clicked.
   Loaded before luneor-core.js; patches window.Luneor once it exists.
   ===================================================================== */
document.addEventListener('DOMContentLoaded', () => {
  const Lu = window.Luneor; if (!Lu) return;
  const { $, $$, Cart, toast, T, REDUCE } = Lu;
  const L = window.LUNEOR || {};

  /* ---------- add to cart: a small product image is thrown on an arc
     from the button into the cart icon, then the cart opens ---------- */
  Lu.flyToCart = function (fromEl, src, done) {
    const cb = $('#cartBtn');
    if (!fromEl || !cb || !src || REDUCE) { done && done(); return; }
    const r = fromEl.getBoundingClientRect(), c = cb.getBoundingClientRect();
    const S = innerWidth < 700 ? 52 : 60;
    const x0 = r.left + r.width / 2, y0 = r.top + r.height / 2;
    const x1 = c.left + c.width / 2, y1 = c.top + c.height / 2;

    const f = document.createElement('div');
    f.className = 'fly-thumb fly-card';
    f.style.cssText = `left:${x0 - S / 2}px;top:${y0 - S / 2}px;width:${S}px;height:${S}px;background-image:url("${src}")`;
    document.body.appendChild(f);

    // arc (quadratic curve) with its apex kept on screen
    const at = (t, a, m, b) => (1 - t) * (1 - t) * a + 2 * t * (1 - t) * m + t * t * b;
    const mx = x0 + (x1 - x0) * .55;
    let my = Math.min(y0, y1) - 160;
    for (let k = 0; k < 20; k++) {
      let top = 1e9; for (let i = 0; i <= 40; i++) top = Math.min(top, at(i / 40, y0, my, y1));
      if (top - S / 2 >= 6) break; my += 12;
    }
    const frames = [], N = 20;
    for (let k = 0; k <= N; k++) {
      const t = k / N;
      frames.push({
        transform: `translate(${at(t, x0, mx, x1) - x0}px,${at(t, y0, my, y1) - y0}px) scale(${1 - .78 * Math.pow(t, 1.8)}) rotate(${t * 25}deg)`,
        opacity: t > .9 ? 1 - (t - .9) * 8 : 1, offset: t
      });
    }
    const a = f.animate(frames, { duration: 800, easing: 'cubic-bezier(.4,0,.6,1)', fill: 'forwards' });
    a.onfinish = () => {
      f.remove(); Cart.bump();
      const plus = document.createElement('span'); plus.className = 'fly-plus'; plus.textContent = '+1';
      plus.style.cssText = `left:${x1}px;top:${c.top}px`; document.body.appendChild(plus);
      setTimeout(() => plus.remove(), 900);
      setTimeout(() => done && done(), 150);
    };
  };

  /* ---------- "you saved 3 on shipping" line under every cart item ---------- */
  const lang = (document.documentElement.lang || 'en').slice(0, 2);
  const SAVED = {
    en: a => `You save <b>${a}</b> with free shipping`,
    fr: a => `<b>${a}</b> économisés grâce à la livraison offerte`,
    de: a => `Sie sparen <b>${a}</b> dank kostenlosem Versand`,
    es: a => `Ahorras <b>${a}</b> con el envío gratis`
  };
  function savedAmount() {
    const cur = (window.LuneorCurrency && window.LuneorCurrency.get()) || 'USD';
    if (cur === 'EUR') return lang === 'en' ? '€3' : '3 €';
    if (cur === 'MXN') return 'MX$60';
    return '$3';
  }
  function shipSaved() {
    const txt = (SAVED[lang] || SAVED.en)(savedAmount());
    $$('#items .item').forEach(it => {
      let el = $('.ship-saved', it);
      if (!el) { el = document.createElement('div'); el.className = 'ship-saved'; el.setAttribute('data-no-cur', ''); (it.children[1] || it).appendChild(el); }
      el.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>' + txt;
    });
  }
  document.addEventListener('luneor:currency', shipSaved);

  /* ---------- upsells ---------- */
  Cart.addId = async function (id, qty = 1) {
    const r = await fetch(L.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: qty }] }) });
    const j = await r.json(); if (!r.ok) throw new Error(j.description || j.message || T.error || 'Error');
    await this.fetch(); this.bump(); return j;
  };
  const baseRender = Cart.render;
  Cart.render = function () {
    baseRender.call(this);
    /* totals that always match the checkout:
       - code already applied to the cart -> show Shopify's own numbers
       - code ticked but not applied yet -> preview it, rounded down to the cent like Shopify */
    const dd = this.data, uc = $('#useCode');
    if (dd && Lu.money) {
      const sub = dd.items_subtotal_price != null ? dd.items_subtotal_price : dd.total_price;
      const applied = (dd.cart_level_discount_applications || []).reduce((s, x) => s + (x.total_allocated_amount || 0), 0);
      let disc = 0, tot = dd.total_price;
      if (applied > 0) disc = applied;
      else if (uc && uc.checked && L.couponPct) { disc = Math.floor(sub * L.couponPct / 100); tot = sub - disc; }
      if ($('#sub')) $('#sub').textContent = Lu.money(sub);
      if ($('#disc')) $('#disc').textContent = '−' + Lu.money(disc);
      if ($('#discRow')) $('#discRow').style.display = disc ? '' : 'none';
      if ($('#tot')) $('#tot').textContent = Lu.money(tot);
    }
    shipSaved();
    const ups = $('#ups'), d = this.data; if (!ups || !d) return;
    // upsells are shown even when the cart is empty
    const inCart = new Set(d.items.map(i => String(i.product_id)));
    let shown = 0;
    $$('[data-up-product]', ups).forEach(u => { const hide = inCart.has(u.dataset.upProduct) || shown >= 3; u.hidden = hide; if (!hide) shown++; });
    ups.hidden = shown === 0;
  };
  $$('[data-up-add]').forEach(b => b.addEventListener('click', async () => {
    b.disabled = true; b.classList.add('loading');
    try { await Cart.addId(b.dataset.upAdd); toast('✦ ' + (b.dataset.upName || '') + ' ' + (T.added || '')); }
    catch (err) { toast(err.message); }
    b.disabled = false; b.classList.remove('loading');
  }));
});